import React, { useMemo } from "react";
import DOMPurify from "dompurify";

export default function Content({ content }) {
    const memoContent = useMemo(() => DOMPurify.sanitize(content, { RETURN_TRUSTED_TYPE: true }), [content]);

    return (
        <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: memoContent }}
        />
    );
}
